import type { PaymentSource } from "./types";

/**
 * Adds the optional `source` filter to a query string.
 *
 * `all` is the server default, so it (like an absent value) sends nothing: a
 * caller that never picks a source makes exactly the request it made before
 * the filter existed.
 */
export function appendPaymentSource(
  params: URLSearchParams,
  source?: PaymentSource | null,
) {
  if (source && source !== "all") params.set("source", source);
}
